module.exports = __webpack_public_path__ + "nl-header-4b47dc.webp";